
import balkonkraftwerkeImg from '@/assets/icons/images/teaser_balkonkraftwerk.jpg';
import oekostromImg from '@/assets/icons/images/teaser_oekostrom.jpg';
import mehrfamilienImg from '@/assets/icons/images/teaser_solarberatung.jpg';

const teaserCardsData = [
    {
        id: "teaser-balkonkraftwerke",
        imageSrc: balkonkraftwerkeImg,
        imageAlt: 'Frau steht an einem Stadtbalkon mit Balkonkraftwerk',
        headline: 'Balkonkraftwerke im Vattenfall Shop',
        text: 'Ein Balkonkraftwerk ist Ihr Einstieg in die private Energiewende: Einfach aufstellen, anstecken und eigenen Sonnenstrom nutzen - ganz ohne großen Aufwand oder technisches Vorwissen.',
        buttonText: 'Zu den Balkonkraftwerken',
        buttonLink: 'https://www.vattenfall.de/solar/balkonkraftwerke'
    },
    {
        id: "teaser-mehfamilien",
        imageSrc: mehrfamilienImg,
        imageAlt: 'Ein Mann im schwarzen T-Shirt steht vor einer Solaranlage.',
        headline: 'Solar für Mehrfamilienhäuser',
        text: 'Als Projektpartner begleiten wir Sie zuverlässig und persönlich zu Ihrer Solaranlage: Von erster Ertragsprognose bis zur Umsetzung.',
        buttonText: 'Zur kostenlosen Solar-Beratung',
        buttonLink: 'https://www.vattenfall.de/geschaeftskunden/ves/solar',
    },
    {
        id: "teaser-oekostrom",
        imageSrc: oekostromImg,
        imageAlt: 'Frau in der Küche prüft auf dem Smartphone ihre Tarifdaten',
        headline: 'Ökostrom im dynamischen Tarif',
        text: 'Mit unserem Tarif ÖkoStrom Dynamik passen Sie Ihren Verbrauch flexibel an den sich stündlich ändernden Börsenpreis an. Keine Abschläge, keine Jahresrechnung - stattdessen verbrauchsscharfe Monatsrechnungen.',
        buttonText: 'Zu ÖkoStrom Dynamik',
        buttonLink: 'https://www.vattenfall.de/strom/tarife/oekostrom-dynamik'
    },
];

export default teaserCardsData;